/**
 * @license
 * @copyright Copyright Motili Inc., 2017 All Rights Reserved
 */

import {
    find,
    findById,
    activateTeamMember as atm,
    deactivateTeamMember as dtm,
    createTeamMember as ctm,
    updateTeamMember as utm,
} from 'common/services/ClientService';
import {
    getChildClientReadPermissionIds,
    getClientId,
} from 'common/services/AuthService';

const baseCompanyQuery = {
    filter: {
        include: [
            {
                relation: 'address',
                scope: {
                    fields: [
                        'rawAddress',
                        'stdAddress',
                        'stdDeliveryLine',
                        'stdLastLine',
                    ],
                },
            },
            {
                relation: 'billingAddress',
                scope: {
                    fields: [
                        'rawAddress',
                        'stdAddress',
                        'stdDeliveryLine',
                        'stdLastLine',
                    ],
                },
            },
            {
                relation: 'team',
                scope: {
                    fields: ['accountId'],
                    include: [
                        {
                            relation: 'account',
                            scope: {
                                fields: [
                                    'id',
                                    'active',
                                    'firstName',
                                    'lastName',
                                    'timezoneId',
                                    'email',
                                    'notificationPreferences',
                                    'createdAt',
                                ],
                                include: [
                                    'childClientPermissions',
                                    {
                                        relation: 'roles',
                                        scope: {
                                            fields: ['name', 'description'],
                                        },
                                    },
                                ],
                            },
                        },
                    ],
                },
            },
            'settings',
            'clientUtilities',
        ],
        fields: [
            'id',
            'statusId',
            'name',
            'doingBusinessAs',
            'website',
            'phone',
            'fax',
            'contact',
            'addressId',
            'billingAddressId',
            'operationInCountry',
            'created',
            'updated',
        ],
    },
};

export function getChildClientCompanies(account) {
    const currentClientId = getClientId();
    const clientIds = [currentClientId];
    const readIds = getChildClientReadPermissionIds(account);
    clientIds.push(...readIds);

    const query = {
        filter: {
            ...baseCompanyQuery.filter,
            where: {
                id: { inq: clientIds },
            },
        },
    };

    return find(query);
}

export function getCompany(id) {
    return findById(id, baseCompanyQuery);
}

export function activateTeamMember(id, teamMemberId) {
    return atm(id, teamMemberId).then(() => getCompany(id));
}

export function deactivateTeamMember(id, teamMemberId) {
    return dtm(id, teamMemberId).then(() => getCompany(id));
}

export function createTeamMember(id, teamMember) {
    return ctm(id, teamMember).then(() => getCompany(id));
}

export function updateTeamMember(id, teamMember) {
    return utm(id, teamMember).then(() => getCompany(id));
}

export function getClientSetting(id) {
    return findById(id, {
        filter: {
            include: ['settings'],
        },
    });
}
